import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';

@Directive({
    selector: '[noLeadingZero]',
    standalone: false
})
export class NoLeadingZeroDirective implements OnInit {
    constructor(public elementRef: ElementRef) {}

    ngOnInit(): void {
        this.transform();
    }

    transform() {
        const value = this.elementRef.nativeElement.value;
        if (value) {
            const numberWithoutLeadingZero = Number(value);
            this.elementRef.nativeElement.value = numberWithoutLeadingZero.toString();
        }
    }

    @HostListener('keyup', ['$event.target.value'])
    change() {
        this.transform();
    }
}
